import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import AccessibilityComponent from './accessibility-component';

const AccessibilityFactory: React.FC = () => {
  return (
    <BaseLayoutFactory>
      <AccessibilityComponent />
    </BaseLayoutFactory>
  );
};

export default AccessibilityFactory;
